export default __webpack_public_path__ + "static/media/featured-project-image.39f977ad.png";